import type { RouteRecordRaw, Router } from 'vue-router'

const JudicialRulingRegistrationRoutes: RouteRecordRaw = {
  path: '/registration/judicialRuling',
  name: 'JudicialRulingModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'JudicialRulingMainRoute',
      component: () => import('./views/JudicialRulingView.vue'),
      meta: {
        title: 'judicialRuling.judicialRuling',
      },
    },
    {
      path: 'create',
      name: 'JudicialRulingCreateRoute',
      component: () => import('./views/JudicialRulingUpsertView.vue'),
      meta: {
        title: 'judicialRuling.createJudicialRuling',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:judicialRulingId',
      name: 'JudicialRulingEditRoute',
      component: () => import('./views/JudicialRulingUpsertView.vue'),
      meta: {
        title: 'judicialRuling.editJudicialRuling',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:judicialRulingId',
      name: 'ViewJudicialRulingRoute',
      component: () => import('./views/SingleJudicialRulingView.vue'),
      meta: {
        title: 'judicialRuling.ViewJudicialRuling',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(JudicialRulingRegistrationRoutes)
}
